<template>
    <div>
        <i
            v-if="priority === 'H'"
            class="fas fa-exclamation fa-fw"
            style="color: #be3813"
        ></i>
        <i
            v-if="priority === 'Z'"
            class="fas fa-arrow-alt-down fa-fw"
            style="color: #005cbf"
        ></i>
    </div>
</template>

<script>
export default {
    name: 'PriorityHandler',

    props: {
        priority: {
            type: String,
            required: false,
            default: '',
        },
    },
}
</script>

<style scoped></style>
